import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Compra } from "@/shared/types/compra";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ComprasQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
    proveedorId?: string,
    articuloId?: string,
    numComprobante?: string
}

export async function getAllCompras(query?: ComprasQuery): Promise<QueryResponse<Compra>> {
    await sleep(1000);
    const response = await api.get("compras", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllComprasQuery(query: ComprasQuery = {}, queryConfig: QueryConfig<QueryResponse<Compra>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCompras(query),
        queryKey: ["compras", query],
    })
}

export interface GetAllCompraQueryProps {
    query: ComprasQuery,
    queryConfig?: QueryConfig<QueryResponse<Compra>>,
    children: (queryResult: QueryResult<QueryResponse<Compra>>) => ReactNode
}

export function GetAllComprasQuery({
    query,
    queryConfig,
    children
}: GetAllCompraQueryProps) {
    const queryResult = useGetAllComprasQuery(query, queryConfig);
    return children && children(queryResult);
}